import { Model } from "@type-r/models";
import { attributes, type } from "@type-r/models/lib/model";
import { Company } from "./company";

export const InsuranceCarrier = attributes({
    insuranceCarrierId: Number,
    insuranceCarrierName: String
});

export abstract class PolicyCardBase extends Model {

    static attributes = {
        id: String,
        status: String,
        name: String,
        insuredParty: Company,
        policyInsuranceCarriers: [ InsuranceCarrier ],
        inceptionDate: type(Date),
        expiryDate: type(Date),
    }
}


